/**
 * Singleton store for assign video popup
 * Selected videos persist across imports
 */
class AssignVideoStore {
	constructor() {
		this.currentCategory = '';
		this.videosByCategory = {};
		this.selectedVideos = [];
	}

	// Category
	setCategory(category) {
		this.currentCategory = category;
	}

	getCategory() {
		return this.currentCategory;
	}

	getVideosByCategory(category) {
		return this.videosByCategory[category] || '';
	}

	addVideosByCategory(category, videos) {
		this.videosByCategory[category] = videos;
	}

	// Videos
	addVideo(videoId) {
		const id = String(videoId);
		if (!this.selectedVideos.includes(id)) {
			this.selectedVideos.push(id);
		}
	}

	removeVideo(videoId) {
		const id = String(videoId);
		this.selectedVideos = this.selectedVideos.filter(v => v !== id);
	}

	isSelected(videoId) {
		return this.selectedVideos.includes(String(videoId));
	}

	getSelectedVideos() {
		return [...this.selectedVideos];
	}

	clearVideos() {
		this.selectedVideos = [];
	}

	// Get count
	getCount() {
		return this.selectedVideos.length;
	}

	setSelectedVideos(videoIds) {
		this.selectedVideos = (videoIds || []).map(id => String(id));
	}
}

/**
 * Singleton store for stage videos
 * Stores videos that are assigned to a stage
 */
class StageVideoStore {
	constructor() {
		this.stageId = null;
		this.videos = [];
	}

	setStageId(id) {
		this.stageId = id;
	}

	getStageId() {
		return this.stageId;
	}

	setVideos(videos) {
		this.videos = videos || [];
	}

	getVideos() {
		return [...this.videos];
	}

	getVideoIds() {
		return this.videos.map(v => String(v.post_id));
	}

	getCount() {
		return this.videos.length;
	}

	clear() {
		this.videos = [];
	}
}

// Export singleton instances
const assignVideoStore = new AssignVideoStore();
const stageVideoStore = new StageVideoStore();
export { assignVideoStore, stageVideoStore };
